
import React from 'react'
import '../styles/_supervition.scss';
import { useTranslation } from 'react-i18next';
import { useNumberFormatter } from '../../../../../hooks/useNumberFormatter';
import { HeaderPmr } from '../../components/HeaderPmr/HeaderPmr';
import NomenclatureItem from '../../components/NomenclatureItem/NomenclatureItem';
import { supervitionProgress, transactionalResources } from '../Common/NomenclatureItems';
import { capitalizeFirstLetter } from '../../../../../services/stringUtil';
import { Bar } from 'react-chartjs-2';
import { GRAPH_REPORT_OPTIONS } from '../Common/GraphsConfiguration';
import SupervitionResumeGraph from '../../components/SupervitionResumeGraph/SupervitionResumeGraph';
import { mapGeneralInfoInDataSource, mapResourcesDataSource } from '../../utils/Helpers/MapperHelper';

export const SupervitionSection = ({ data }) => {
    const { t } = useTranslation();
    const { formatNumber } = useNumberFormatter();

    const dataSource = data.sectionSixSupervision;

    const {
        projectFinalized,
        transactionalResourceSupervision
    } = dataSource;


    const updatedTransactionalResourcesData = mapResourcesDataSource(transactionalResourceSupervision);

    return (
        <section className='supervition-report'>
            <HeaderPmr data={mapGeneralInfoInDataSource(data)} />
            <article className="supervition-info-report">
                <h3 className='content-layout-title'>{t('extended_report.supervition')}</h3>
                <section className='supervition-info-layout'>
                    <div className='comparisson-project-finished'>
                        <div className='comparisson-project-finished-header'>
                            <h3 className="chart-title">{capitalizeFirstLetter(t('projected_vs_finished'))}</h3>
                            <NomenclatureItem data={supervitionProgress} />
                        </div>
                        <div className='comparisson-project-finished-content'>
                            <SupervitionResumeGraph chart={projectFinalized.projectFinalizedDetailsForMonth?.map(item => { return { current: item.actualProducts, projected: item.plannedProducts } })} title={t('critical_products')} />
                            <SupervitionResumeGraph chart={projectFinalized.projectFinalizedDetailsForMonth?.map(item => { return { current: item.actualActivities, projected: item.plannedActivities } })} title={t('activity')} />
                        </div>
                    </div>
                    <div className='resources'>
                        <h3 className="chart-title">{t('transactional_resources_for_supervision')}</h3>
                        <div className='resources-graph'>
                            <NomenclatureItem data={transactionalResources.map((data, index) => {
                                data.titleCompose = `${t('total')} ${capitalizeFirstLetter(t(data.title))}`;
                                data.description = t('dolar_sign') + ' ' + formatNumber(updatedTransactionalResourcesData.totals[index]);
                                return data;
                            })} />
                            <Bar data={updatedTransactionalResourcesData} options={GRAPH_REPORT_OPTIONS} redraw={true} />
                        </div>
                    </div>
                </section>
            </article>
        </section >
    );
};
